"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pendingSSORequestsAPICall = exports.verifyOTP = exports.sendOTP = void 0;
const endpoint_1 = __importDefault(require("./endpoint"));
const instance_1 = __importDefault(require("./instance"));
const sendOTP = (_a) => __awaiter(void 0, [_a], void 0, function* ({ phone, token }) {
    const response = yield instance_1.default.post(endpoint_1.default.loginSendOtp(), {
        phone: phone,
    }, {
        headers: {
            'x-captcha-token': token,
        },
    });
    return response;
});
exports.sendOTP = sendOTP;
const verifyOTP = (_a) => __awaiter(void 0, [_a], void 0, function* ({ otp, phone }) {
    const response = yield instance_1.default.post(endpoint_1.default.loginVerifyOtp(), {
        phone: phone,
        otp: otp,
    });
    return response;
});
exports.verifyOTP = verifyOTP;
const pendingSSORequestsAPICall = (url) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield instance_1.default.get(url);
    return response;
});
exports.pendingSSORequestsAPICall = pendingSSORequestsAPICall;
//# sourceMappingURL=index.js.map